import {CustomMenuItem} from '../../components/common/arr-menu/ArrMenu';
import {t} from 'i18next';

export const userDetailsMoreMenu: CustomMenuItem[] = [
  {label: 'Edit', id: 'edit'},
  {label: 'Delete', id: 'delete'},
];

export const TABS = [
  t('securityGroup.folders'),
  t('securityGroup.keywords'),
  t('securityGroup.tags'),
  t('securityGroup.comments'),
  t('securityGroup.annotationLayers'),
  t('securityGroup.projectFields'),
  t('securityGroup.redactionTags'),
] as const;

export const tabToKey: Record<string, string> = {
  [t('securityGroup.folders')]: 'FolderList',
  [t('securityGroup.keywords')]: 'KeywordsList',
  [t('securityGroup.tags')]: 'TagsList',
  [t('securityGroup.comments')]: 'CommentsList',
  [t('securityGroup.annotationLayers')]: 'AnnotationLayersList',
  [t('securityGroup.projectFields')]: 'ProjectFieldsList',
  [t('securityGroup.redactionTags')]: 'RedactionTagsList',
};

export const tabToSelectedKey: Record<string, string> = {
  [t('securityGroup.folders')]: 'FolderListSelected',
  [t('securityGroup.keywords')]: 'KeywordsListSelected',
  [t('securityGroup.tags')]: 'TagsListSelected',
  [t('securityGroup.comments')]: 'CommentsListSelected',
  [t('securityGroup.annotationLayers')]: 'AnnotationLayersListSelected',
  [t('securityGroup.projectFields')]: 'ProjectFieldsListSelected',
  [t('securityGroup.redactionTags')]: 'RedactionTagsListSelected',
};
